<template>
  <modal v-bind="$attrs" v-on="$listeners" :title="getTitle">
    <template v-slot:body>
      <p>
        {{
          $t("study_sets.modals.edit_class.description")
        }}
      </p>
    </template>
    <template v-slot:footer>
      <span class="dialog-footer">
        <primary-button
          class="confirm-save"
          ref="submitEditOrganizationUserButton"
          @click.native="handleSubmitDeleteUsers"
        >
          {{ $t('common.save') }}
        </primary-button>
        <tertiary-button @click.native="$emit('closed')">
          {{ $t('common.cancel') }}
        </tertiary-button>
      </span>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import { mapGetters } from "vuex";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import TertiaryButton from "@/components/common/buttons/TertiaryButton";

export default {
  props: {
    numberOfSelectedUsers: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton,
  },
  data() {
    return {
      isRemoveUserFromSystem: false,
    };
  },

  computed: {
    ...mapGetters("user", ["isElsaAdmin"]),
    getTitle() {
      return this.$t('study_sets.modals.edit_class.title_save')
    },
  },
  methods: {
    handleSubmitDeleteUsers() {
      this.$emit("closed");
      this.$emit("saveInfo", this.isRemoveUserFromSystem);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
p {
  margin: 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
}
.elsa-button.confirm-delete,
.elsa-button.confirm-delete:hover {
  background: $orange;
  border-radius: 8px;
}
.elsa-checkbox {
  display: inline-block !important;
  margin-left:auto !important;
  margin-right:auto !important;
}
</style>
